<div [ngClass]="{ 'mb-3': isMobile }" class="created-modal text-center">
  <h1>{{ paymentStatus }}</h1>

  <p>{{ paymentDescription }}</p>

  <button
    (click)="close()"
    class="button-simple shock-pink sm-35 margin-centered"
  >
    {{ requestStatusBtnText }}
  </button>
</div>
